import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import MiddleCard from "../../components/MiddleCard";
import SubcriptionScreen from "../SubcriptionScreen/index";
import Topbar from "../../components/Topbar";
import Navigation from "../../components/Navigation";
import { ReactComponent as SupportIcon } from "../../assets/svgs/support.svg";
import Bottombar from "../../components/Bottombar";
import { Link } from "react-router-dom";

function Homepage() {
  const [displaySubscription, setDisplaySubscription] = useState(false);

  // useTimeout(() => setIdle(false), 1000 * 10);
  // clearTimeout(() => setIdle(false))
  useEffect(() => {
    setTimeout(() => openSubscription(), 1000 * 5);
  }, []);

  const closeSubscription = () => {
    setDisplaySubscription(false);
  };
  const openSubscription = () => {
    setDisplaySubscription(true);
  };

  return (
    <div className="dark:bg-black bg-white min-h-screen w-full">
      {displaySubscription === false ? (
        <div className="relative min-h-screen overflow-y-auto">
          <Topbar />
          <Header />
          <div className="flex flex-col mt-2 dark:bg-black bg-white">
            <div className="bg-white dark:bg-black overflow-x-hidden overflow-y-auto min-h-[70vh] sm:min-h-[75vh] w-full z-10 pb-20 sm:pb-4">
              <div>
                <div className="text-black dark:text-white font-sans font-bold text-lg sm:text-xl lg:text-2xl sm:ml-20 ml-3 mt-4">
                  About us
                </div>
                <div className="bg-white dark:bg-black">
                  <MiddleCard />
                </div>
              </div>
              <div>
                <div className="text-black font-sans font-bold text-lg sm:text-xl lg:text-2xl sm:ml-20 ml-3 mt-6 dark:text-white">
                  Navigation
                </div>
                <Navigation />
              </div>
              <div>
                <div className="text-black dark:text-white font-sans font-bold text-lg sm:text-xl lg:text-2xl sm:ml-20 ml-3 mt-6">
                  Support
                </div>
                <div className="sm:mt-5 ml-3 mt-3 flex w-full justify-center px-2">
                  <div className="flex sm:gap-2 flex-col pb-6 font-bold items-center justify-center bg-white dark:text-white dark:bg-black cursor-pointer aboutUsShadow rounded-[20px] w-full max-w-md sm:h-[166px] h-[140px] mb-10 transition-shadow hover:shadow-lg">
                    <SupportIcon className="text-black dark:text-white mb-2" />
                    <Link to={'/support'} className="text-center hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Customer Service Help Line</Link>
                    <Link to={'/faqs'} className="text-center hover:text-blue-600 dark:hover:text-blue-400 transition-colors">FAQS</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sm:hidden absolute bottom-0 z-40 w-full">
            <Bottombar activeBar="home" />
          </div>
        </div>
      ) : (
        <div>
          <SubcriptionScreen ClosureCallback={closeSubscription} />
        </div>
      )}
    </div>
  );
}

export default Homepage;
